"use client"
import anime from "animejs"
import React from 'react';
import { useState, useEffect} from 'react';

const AnimatedProfile = () =>{
    const [pic, setPic]=useState("./assets/memoji.jpg");
    
    const path1 = "M344.46 65.5389C372.954 145.565 289.214 338.797 146.744 329.689C38.1414 322.745 -2.5148e-05 272.435 0 170.288C3.37977e-05 33.0081 88.0134 -38.5595 138.908 21.2971C194.866 142.312 298.869 -36.6077 344.46 65.5389Z" 
    const path2 = "M361 145C391.692 230.361 331.461 363.716 178 354C61.0193 346.594 -44.0001 208 19 145C122.259 41.7406 58 19 185 0C309 0 311.893 36.0436 361 145Z"
    const path3 = "M364 138C347.911 244 309 289 181 347C74.2344 395.378 82 251 22.0001 138C-48.3446 5.51744 66 63 190 13C302 -26 381 26 364 138Z" 
    const path4 = "M344 235C292.064 328.795 308 373 137 344C21.4352 324.402 -37.8815 304.068 29 195C94 89 29 55 146 10.0001C272.949 -38.8262 411 114 344 235Z"
    const path5 = "M355 211C334 324 189.216 468.461 86 330C45 275 -37 336 21 187C66.1049 71.127 91.0678 110.199 181 19C252 -53 375.829 98.919 355 211Z"
    const timeline= anime.timeline(
        {
            loop: true,
            easing:"linear",
            borderColor: ['#FC6C85'],

        }
    );


    const startTimeline = () =>{
        const container = document.getElementById("animation");

        
        timeline
        .add({
            targets: container,
            d:[
                {value:path2}
            ]
        })
        .add({
            targets: container,
            d:[
                {value:path4}
            ]
        })
        .add({
            targets:container,
            d:[
                {value:path3}
            ]
        })
        .add({
            targets:container,
            d:[
                {value:path5}
            ]
        })
        .add({
            targets:container,
            d:[
                {value:path1}
            ]
        });
    }

    useEffect(() => {
        startTimeline();
      }, []);

    

    return(
        <div className="p-0 m-0">    
        <svg width="280" height="350" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>    
                <clipPath id="mask">
                
                <path id="animation"  d="M344.46 65.5389C372.954 145.565 289.214 338.797 146.744 329.689C38.1414 322.745 -2.5148e-05 272.435 0 170.288C3.37977e-05 33.0081 88.0134 -38.5595 138.908 21.2971C194.866 142.312 298.869 -36.6077 344.46 65.5389Z" 
 fill="#D9D9D9"/>

                </clipPath>
            </defs>

            <image id="image" width="100%" height="100%" clip-path="url(#mask)" onMouseEnter={ () => {setPic("./assets/profile.jpg")} } onMouseLeave={ () => {setPic("./assets/memoji.jpg")} } x="-20px" y="-10px" href={pic} className='h-[400px] w-[400px] scale-75'/>
        </svg>
        </div> 

    );
};

export default AnimatedProfile;

